<h1>Frequently Asked Questions</h1>
<ng-container *ngIf="true">
  <div class="w-50 m-auto mb-2 border">
    <app-video-js-player videourl="https://learn.cdn.abmp.com/public/ng/demo.mp4"></app-video-js-player>
  </div>

  <app-dynamic-content blocktitle="Help Page"></app-dynamic-content>

  <div id="debug" class="mt-5">
    <p><a href="https://www.whatsmybrowser.org/" target="_blank">Browser detail</a> :: <a [routerLink]="null" (click)="ToggleHLS()">Disable HLS Video</a></p>
  </div>
</ng-container>